import { Component, Input, OnInit } from '@angular/core';
import { Price } from '../../../models/price';
import { ChargeClassEnum } from '../../../enum/charge-class.enum';
import { Surcharge } from '../../../models/surcharge';
import { MoneyPipe } from '../pipes/money.pipe';
import { MatDivider } from '@angular/material/divider';


@Component({
    selector: 'app-price-breakdown',
    templateUrl: './price-breakdown.component.html',
    styleUrls: ['./price-breakdown.component.scss'],
    imports: [MatDivider, MoneyPipe]
})
export class PriceBreakdownComponent implements OnInit {

    @Input()
    set price(price: Price) { this.localPrice = { currency: null, net: 0, gross: 0, baseFreight: 0, surcharges: [], ...price }; }
    get price(): Price { return this.localPrice; }
    private localPrice: Price;

    @Input()
    set comparison(comparison: Price) { this.localComparison = { ...comparison }; }
    get comparison(): Price { return this.localComparison; }
    private localComparison: Price;

    @Input()
    comparisonRatio = 1;

    constructor() {
    }

    ngOnInit(): void {
    }

    currency(): string {
        return this.price?.currency;
    }

    baseFreight(): number {
        if (this.comparison && this.price) {
            const compareFreight = this.comparison.baseFreight * this.comparisonRatio;
            if (compareFreight > this.price.baseFreight) {
                return compareFreight;
            }
        }
        return this.price ? this.price.baseFreight : 0;
    }

    showDiscount(): boolean {
        return (this.baseFreight() > this.price?.baseFreight);
    }

    discount(): number {
        return -(this.baseFreight() - this.price?.baseFreight);
    }

    nonTaxSurcharges(): Surcharge[] {
        return this.price ? this.price.surcharges.filter((s) => s.class !== ChargeClassEnum.TAX) : [];
    }

    taxSurcharges(): Surcharge[] {
        return this.price ? this.price.surcharges.filter((s) => s.class === ChargeClassEnum.TAX) : [];
    }

    showTaxes(): boolean {
        const taxes = this.taxSurcharges();
        return (taxes.length > 0);
    }

}
